// import React, { useState } from 'react';

// const SalarySetup = () => {
//   const [activeTab, setActiveTab] = useState('structure');
//   const [salaryData, setSalaryData] = useState({
//     basic: 30000,
//     hra: 10000,
//     da: 5000,
//     conveyance: 2000,
//     medical: 3000,
//     other: 0,
//     deductions: {
//       pf: 1800,
//       esi: 750,
//       tds: 2000,
//       loan: 0,
//       other: 0
//     }
//   });

//   const employees = [
//     { id: 1, name: 'John Doe', designation: 'Software Engineer' },
//     { id: 2, name: 'Jane Smith', designation: 'Product Manager' },
//     { id: 3, name: 'Robert Johnson', designation: 'UX Designer' },
//     { id: 4, name: 'Sarah Wilson', designation: 'QA Engineer' }
//   ];

//   const handleInputChange = (e, category = null) => {
//     const { name, value } = e.target;
    
//     if (category) {
//       setSalaryData(prev => ({
//         ...prev,
//         [category]: {
//           ...prev[category],
//           [name]: Number(value)
//         }
//       }));
//     } else {
//       setSalaryData(prev => ({
//         ...prev,
//         [name]: Number(value)
//       }));
//     }
//   };

//   const calculateTotalAllowances = () => {
//     return salaryData.hra + salaryData.da + salaryData.conveyance + 
//            salaryData.medical + salaryData.other;
//   };

//   const calculateTotalDeductions = () => {
//     const { pf, esi, tds, loan, other } = salaryData.deductions;
//     return pf + esi + tds + loan + other;
//   };

//   const calculateNetSalary = () => {
//     return salaryData.basic + calculateTotalAllowances() - calculateTotalDeductions();
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
//       <div className="max-w-6xl mx-auto">
//         <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
//           <h1 className="text-3xl font-bold text-gray-800 mb-2">Salary Setup ⚙️</h1>
//           <p className="text-gray-600">Used by HR/Admin to configure employee salary components</p>
//         </div>

//         {/* Navigation Tabs */}
//         <div className="flex flex-wrap gap-2 mb-6">
//           <button
//             onClick={() => setActiveTab('structure')}
//             className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'structure' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
//           >
//             Define Salary Structure
//           </button>
//           <button
//             onClick={() => setActiveTab('assign')}
//             className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'assign' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
//           >
//             Assign Salary Structure
//           </button>
//           <button
//             onClick={() => setActiveTab('edit')}
//             className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'edit' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
//           >
//             Edit/Update Salary
//           </button>
//         </div>

//         {/* Salary Structure Tab */}
//         {activeTab === 'structure' && (
//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <h2 className="text-xl font-semibold text-gray-800 mb-6">Define Salary Structure</h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Earnings Section */}
//               <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5">
//                 <h3 className="font-bold text-lg text-indigo-800 mb-4">Earnings</h3>
                
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Basic Salary</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="basic"
//                         value={salaryData.basic}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">HRA (House Rent Allowance)</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="hra"
//                         value={salaryData.hra}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">DA (Dearness Allowance)</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="da"
//                         value={salaryData.da}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Conveyance Allowance</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="conveyance"
//                         value={salaryData.conveyance}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Medical Allowance</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="medical"
//                         value={salaryData.medical}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Other Allowances</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="other"
//                         value={salaryData.other}
//                         onChange={handleInputChange}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
              
//               {/* Deductions Section */}
//               <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-5">
//                 <h3 className="font-bold text-lg text-red-800 mb-4">Deductions</h3>
                
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Provident Fund (PF)</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="pf"
//                         value={salaryData.deductions.pf}
//                         onChange={(e) => handleInputChange(e, 'deductions')}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">ESI</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="esi"
//                         value={salaryData.deductions.esi}
//                         onChange={(e) => handleInputChange(e, 'deductions')}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">TDS</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="tds"
//                         value={salaryData.deductions.tds}
//                         onChange={(e) => handleInputChange(e, 'deductions')}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Loan</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="loan"
//                         value={salaryData.deductions.loan}
//                         onChange={(e) => handleInputChange(e, 'deductions')}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Other Deductions</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         name="other"
//                         value={salaryData.deductions.other}
//                         onChange={(e) => handleInputChange(e, 'deductions')}
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Salary Summary */}
//             <div className="mt-8 bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-5">
//               <h3 className="font-bold text-lg text-purple-800 mb-4">Salary Summary</h3>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-2">Earnings</h4>
//                   <div className="space-y-2">
//                     <div className="flex justify-between">
//                       <span>Basic Salary:</span>
//                       <span className="font-medium">₹{salaryData.basic.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>HRA:</span>
//                       <span className="font-medium">₹{salaryData.hra.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>DA:</span>
//                       <span className="font-medium">₹{salaryData.da.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>Conveyance:</span>
//                       <span className="font-medium">₹{salaryData.conveyance.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>Medical:</span>
//                       <span className="font-medium">₹{salaryData.medical.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>Other Allowances:</span>
//                       <span className="font-medium">₹{salaryData.other.toLocaleString()}</span>
//                     </div>
//                     <div className="border-t pt-2 mt-2 font-semibold flex justify-between text-blue-700">
//                       <span>Total Earnings:</span>
//                       <span>₹{(salaryData.basic + calculateTotalAllowances()).toLocaleString()}</span>
//                     </div>
//                   </div>
//                 </div>
                
//                 <div>
//                   <h4 className="font-medium text-gray-700 mb-2">Deductions</h4>
//                   <div className="space-y-2">
//                     <div className="flex justify-between">
//                       <span>PF:</span>
//                       <span className="font-medium">₹{salaryData.deductions.pf.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>ESI:</span>
//                       <span className="font-medium">₹{salaryData.deductions.esi.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>TDS:</span>
//                       <span className="font-medium">₹{salaryData.deductions.tds.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>Loan:</span>
//                       <span className="font-medium">₹{salaryData.deductions.loan.toLocaleString()}</span>
//                     </div>
//                     <div className="flex justify-between">
//                       <span>Other Deductions:</span>
//                       <span className="font-medium">₹{salaryData.deductions.other.toLocaleString()}</span>
//                     </div>
//                     <div className="border-t pt-2 mt-2 font-semibold flex justify-between text-red-700">
//                       <span>Total Deductions:</span>
//                       <span>₹{calculateTotalDeductions().toLocaleString()}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="mt-6 pt-4 border-t border-gray-200">
//                 <div className="flex justify-between items-center text-xl font-bold">
//                   <span className="text-gray-800">Net Salary:</span>
//                   <span className="text-green-700">₹{calculateNetSalary().toLocaleString()}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
        
//         {/* Assign Salary Structure Tab */}
//         {activeTab === 'assign' && (
//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <h2 className="text-xl font-semibold text-gray-800 mb-6">Assign Salary Structure</h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Select Employee</label>
//                 <select className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
//                   <option value="">Select an employee</option>
//                   {employees.map(emp => (
//                     <option key={emp.id} value={emp.id}>{emp.name} - {emp.designation}</option>
//                   ))}
//                 </select>
//               </div>
              
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Select Designation</label>
//                 <select className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
//                   <option value="">Select a designation</option>
//                   <option value="software-engineer">Software Engineer</option>
//                   <option value="product-manager">Product Manager</option>
//                   <option value="ux-designer">UX Designer</option>
//                   <option value="qa-engineer">QA Engineer</option>
//                 </select>
//               </div>
//             </div>
            
//             <div className="mt-6">
//               <h3 className="font-medium text-gray-700 mb-4">Current Salary Structure</h3>
              
//               <div className="bg-gray-50 rounded-lg p-4 mb-6">
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-gray-600">Basic Salary:</span>
//                   <span className="font-medium">₹30,000</span>
//                 </div>
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-gray-600">HRA:</span>
//                   <span className="font-medium">₹10,000</span>
//                 </div>
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-gray-600">DA:</span>
//                   <span className="font-medium">₹5,000</span>
//                 </div>
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-gray-600">Conveyance:</span>
//                   <span className="font-medium">₹2,000</span>
//                 </div>
//                 <div className="flex justify-between items-center mb-2">
//                   <span className="text-gray-600">Medical:</span>
//                   <span className="font-medium">₹3,000</span>
//                 </div>
//                 <div className="border-t pt-2 mt-2 flex justify-between items-center font-semibold">
//                   <span className="text-gray-700">Net Salary:</span>
//                   <span className="text-green-700">₹42,000</span>
//                 </div>
//               </div>
              
//               <button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow">
//                 Assign Salary Structure
//               </button>
//             </div>
//           </div>
//         )}
        
//         {/* Edit/Update Salary Tab */}
//         {activeTab === 'edit' && (
//           <div className="bg-white rounded-xl shadow-lg p-6">
//             <h2 className="text-xl font-semibold text-gray-800 mb-6">Edit/Update Salary Components</h2>
            
//             <div className="mb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">Select Employee</label>
//               <select className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
//                 <option value="">Select an employee</option>
//                 {employees.map(emp => (
//                   <option key={emp.id} value={emp.id}>{emp.name} - {emp.designation}</option>
//                 ))}
//               </select>
//             </div>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-4">Current Salary Structure</h3>
                
//                 <div className="bg-gray-50 rounded-lg p-4 mb-4">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-gray-600">Basic Salary:</span>
//                     <span className="font-medium">₹30,000</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-gray-600">HRA:</span>
//                     <span className="font-medium">₹10,000</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-gray-600">DA:</span>
//                     <span className="font-medium">₹5,000</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-gray-600">Conveyance:</span>
//                     <span className="font-medium">₹2,000</span>
//                   </div>
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-gray-600">Medical:</span>
//                     <span className="font-medium">₹3,000</span>
//                   </div>
//                   <div className="border-t pt-2 mt-2 flex justify-between items-center font-semibold">
//                     <span className="text-gray-700">Net Salary:</span>
//                     <span className="text-green-700">₹42,000</span>
//                   </div>
//                 </div>
//               </div>
              
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-4">Update Salary Components</h3>
                
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Basic Salary</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                         placeholder="Enter new basic salary"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">HRA</label>
//                     <div className="relative">
//                       <span className="absolute left-3 top-2 text-gray-500">₹</span>
//                       <input
//                         type="number"
//                         className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                         placeholder="Enter new HRA"
//                       />
//                     </div>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Update</label>
//                     <select className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
//                       <option value="">Select a reason</option>
//                       <option value="promotion">Promotion</option>
//                       <option value="revision">Salary Revision</option>
//                       <option value="correction">Correction</option>
//                       <option value="other">Other</option>
//                     </select>
//                   </div>
                  
//                   <button className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow">
//                     Update Salary
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SalarySetup;




import React, { useState } from 'react';

const SalarySetup = () => {
  const [activeTab, setActiveTab] = useState('structure');
  const [selectedDepartment, setSelectedDepartment] = useState('engineering');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [selectedDesignation, setSelectedDesignation] = useState('');
  
  const departments = [
    { id: 'engineering', name: 'Engineering' },
    { id: 'marketing', name: 'Marketing' },
    { id: 'sales', name: 'Sales' },
    { id: 'hr', name: 'Human Resources' },
    { id: 'finance', name: 'Finance' }
  ];

  const designations = [
    { id: 'software-engineer', name: 'Software Engineer', department: 'engineering' },
    { id: 'senior-engineer', name: 'Senior Software Engineer', department: 'engineering' },
    { id: 'product-manager', name: 'Product Manager', department: 'marketing' },
    { id: 'sales-executive', name: 'Sales Executive', department: 'sales' },
    { id: 'hr-manager', name: 'HR Manager', department: 'hr' },
    { id: 'accountant', name: 'Accountant', department: 'finance' }
  ];

  const employees = [
    { id: 1, name: 'John Doe', designation: 'software-engineer', department: 'engineering' },
    { id: 2, name: 'Jane Smith', designation: 'product-manager', department: 'marketing' },
    { id: 3, name: 'Robert Johnson', designation: 'senior-engineer', department: 'engineering' },
    { id: 4, name: 'Sarah Wilson', designation: 'sales-executive', department: 'sales' },
    { id: 5, name: 'Michael Brown', designation: 'hr-manager', department: 'hr' }
  ];

  const [salaryStructures, setSalaryStructures] = useState({
    engineering: {
      basic: 30000,
      hra: 10000,
      da: 5000,
      conveyance: 2000,
      medical: 3000,
      other: 0,
      deductions: {
        pf: 1800,
        esi: 750,
        tds: 2000,
        loan: 0,
        other: 0
      }
    },
    marketing: {
      basic: 35000,
      hra: 12000,
      da: 6000,
      conveyance: 2500,
      medical: 3500,
      other: 0,
      deductions: {
        pf: 2100,
        esi: 875,
        tds: 2500,
        loan: 0,
        other: 0
      }
    },
    sales: {
      basic: 25000,
      hra: 8000,
      da: 4000,
      conveyance: 3000,
      medical: 2500,
      other: 5000, // Sales commission
      deductions: {
        pf: 1500,
        esi: 625,
        tds: 1500,
        loan: 0,
        other: 0
      }
    },
    hr: {
      basic: 32000,
      hra: 11000,
      da: 5500,
      conveyance: 2000,
      medical: 3200,
      other: 0,
      deductions: {
        pf: 1920,
        esi: 800,
        tds: 2200,
        loan: 0,
        other: 0
      }
    },
    finance: {
      basic: 38000,
      hra: 13000,
      da: 7000,
      conveyance: 2500,
      medical: 3800,
      other: 0,
      deductions: {
        pf: 2280,
        esi: 950,
        tds: 2800,
        loan: 0,
        other: 0
      }
    }
  });

  const handleInputChange = (e, category = null) => {
    const { name, value } = e.target;
    
    if (category) {
      setSalaryStructures(prev => ({
        ...prev,
        [selectedDepartment]: {
          ...prev[selectedDepartment],
          [category]: {
            ...prev[selectedDepartment][category],
            [name]: Number(value)
          }
        }
      }));
    } else {
      setSalaryStructures(prev => ({
        ...prev,
        [selectedDepartment]: {
          ...prev[selectedDepartment],
          [name]: Number(value)
        }
      }));
    }
  };

  const calculateTotalAllowances = (dept) => {
    const data = salaryStructures[dept];
    return data.hra + data.da + data.conveyance + data.medical + data.other;
  };

  const calculateTotalDeductions = (dept) => {
    const { pf, esi, tds, loan, other } = salaryStructures[dept].deductions;
    return pf + esi + tds + loan + other;
  };

  const calculateNetSalary = (dept) => {
    const data = salaryStructures[dept];
    return data.basic + calculateTotalAllowances(dept) - calculateTotalDeductions(dept);
  };

  const handleSaveStructure = () => {
    // In a real app, this would save to a backend
    alert(`Salary structure for ${departments.find(d => d.id === selectedDepartment)?.name} saved successfully!`);
  };

  const handleAssignStructure = () => {
    // In a real app, this would assign the structure to selected employees/designations
    const empName = employees.find(e => e.id === parseInt(selectedEmployee))?.name || 'selected employees';
    alert(`Salary structure assigned to ${empName} successfully!`);
  };

  const handleUpdateSalary = () => {
    // In a real app, this would update the salary components
    alert('Salary components updated successfully!');
  };

  const handleDeleteStructure = () => {
    if (window.confirm('Are you sure you want to delete this salary structure? This action cannot be undone.')) {
      // In a real app, this would delete the structure
      alert('Salary structure deleted successfully!');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Salary Setup ⚙️</h1>
          <p className="text-gray-600">Used by HR/Admin to configure employee salary components</p>
        </div>

        {/* Navigation Tabs */}
        <div className="flex flex-wrap gap-2 mb-6">
          <button
            onClick={() => setActiveTab('structure')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'structure' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
          >
            Define Salary Structure
          </button>
          <button
            onClick={() => setActiveTab('assign')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'assign' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
          >
            Assign Salary Structure
          </button>
          <button
            onClick={() => setActiveTab('edit')}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === 'edit' ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'}`}
          >
            Edit/Update Salary
          </button>
        </div>

        {/* Salary Structure Tab */}
        {activeTab === 'structure' && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold text-gray-800">Define Salary Structure</h2>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Department:</label>
                <select 
                  value={selectedDepartment} 
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                  className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {departments.map(dept => (
                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                  ))}
                </select>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Earnings Section */}
              <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5">
                <h3 className="font-bold text-lg text-indigo-800 mb-4">Earnings</h3>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Basic Salary</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="basic"
                        value={salaryStructures[selectedDepartment].basic}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">HRA (House Rent Allowance)</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="hra"
                        value={salaryStructures[selectedDepartment].hra}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">DA (Dearness Allowance)</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="da"
                        value={salaryStructures[selectedDepartment].da}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Conveyance Allowance</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="conveyance"
                        value={salaryStructures[selectedDepartment].conveyance}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Medical Allowance</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="medical"
                        value={salaryStructures[selectedDepartment].medical}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Other Allowances</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="other"
                        value={salaryStructures[selectedDepartment].other}
                        onChange={handleInputChange}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Deductions Section */}
              <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-5">
                <h3 className="font-bold text-lg text-red-800 mb-4">Deductions</h3>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Provident Fund (PF)</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="pf"
                        value={salaryStructures[selectedDepartment].deductions.pf}
                        onChange={(e) => handleInputChange(e, 'deductions')}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">ESI</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="esi"
                        value={salaryStructures[selectedDepartment].deductions.esi}
                        onChange={(e) => handleInputChange(e, 'deductions')}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">TDS</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="tds"
                        value={salaryStructures[selectedDepartment].deductions.tds}
                        onChange={(e) => handleInputChange(e, 'deductions')}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Loan</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="loan"
                        value={salaryStructures[selectedDepartment].deductions.loan}
                        onChange={(e) => handleInputChange(e, 'deductions')}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Other Deductions</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        name="other"
                        value={salaryStructures[selectedDepartment].deductions.other}
                        onChange={(e) => handleInputChange(e, 'deductions')}
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Salary Summary */}
            <div className="mt-8 bg-gradient-to-r from-purple-50 to-blue-50 rounded-xl p-5">
              <h3 className="font-bold text-lg text-purple-800 mb-4">Salary Summary for {departments.find(d => d.id === selectedDepartment)?.name}</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-medium text-gray-700 mb-2">Earnings</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>Basic Salary:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].basic.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>HRA:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].hra.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>DA:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].da.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Conveyance:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].conveyance.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Medical:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].medical.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Other Allowances:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].other.toLocaleString()}</span>
                    </div>
                    <div className="border-t pt-2 mt-2 font-semibold flex justify-between text-blue-700">
                      <span>Total Earnings:</span>
                      <span>₹{(salaryStructures[selectedDepartment].basic + calculateTotalAllowances(selectedDepartment)).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
                
                <div>
                  <h4 className="font-medium text-gray-700 mb-2">Deductions</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span>PF:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].deductions.pf.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>ESI:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].deductions.esi.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>TDS:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].deductions.tds.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Loan:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].deductions.loan.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Other Deductions:</span>
                      <span className="font-medium">₹{salaryStructures[selectedDepartment].deductions.other.toLocaleString()}</span>
                    </div>
                    <div className="border-t pt-2 mt-2 font-semibold flex justify-between text-red-700">
                      <span>Total Deductions:</span>
                      <span>₹{calculateTotalDeductions(selectedDepartment).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex justify-between items-center text-xl font-bold">
                  <span className="text-gray-800">Net Salary:</span>
                  <span className="text-green-700">₹{calculateNetSalary(selectedDepartment).toLocaleString()}</span>
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-4">
              <button 
                onClick={handleDeleteStructure}
                className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow"
              >
                Delete Structure
              </button>
              <button 
                onClick={handleSaveStructure}
                className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow"
              >
                Save Structure
              </button>
            </div>
          </div>
        )}
        
        {/* Assign Salary Structure Tab */}
        {activeTab === 'assign' && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Assign Salary Structure</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Department</label>
                <select 
                  value={selectedDepartment} 
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {departments.map(dept => (
                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Designation</label>
                <select 
                  value={selectedDesignation} 
                  onChange={(e) => setSelectedDesignation(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select a designation</option>
                  {designations
                    .filter(des => des.department === selectedDepartment)
                    .map(des => (
                      <option key={des.id} value={des.id}>{des.name}</option>
                    ))
                  }
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Employee</label>
                <select 
                  value={selectedEmployee} 
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select an employee</option>
                  {employees
                    .filter(emp => emp.department === selectedDepartment)
                    .map(emp => (
                      <option key={emp.id} value={emp.id}>{emp.name}</option>
                    ))
                  }
                </select>
              </div>
            </div>
            
            <div className="mt-6">
              <h3 className="font-medium text-gray-700 mb-4">Salary Structure for {departments.find(d => d.id === selectedDepartment)?.name}</h3>
              
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Basic Salary:</span>
                  <span className="font-medium">₹{salaryStructures[selectedDepartment].basic.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">HRA:</span>
                  <span className="font-medium">₹{salaryStructures[selectedDepartment].hra.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">DA:</span>
                  <span className="font-medium">₹{salaryStructures[selectedDepartment].da.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Conveyance:</span>
                  <span className="font-medium">₹{salaryStructures[selectedDepartment].conveyance.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-600">Medical:</span>
                  <span className="font-medium">₹{salaryStructures[selectedDepartment].medical.toLocaleString()}</span>
                </div>
                <div className="border-t pt-2 mt-2 flex justify-between items-center font-semibold">
                  <span className="text-gray-700">Net Salary:</span>
                  <span className="text-green-700">₹{calculateNetSalary(selectedDepartment).toLocaleString()}</span>
                </div>
              </div>
              
              <button 
                onClick={handleAssignStructure}
                className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow"
              >
                Assign Salary Structure
              </button>
            </div>
          </div>
        )}
        
        {/* Edit/Update Salary Tab */}
        {activeTab === 'edit' && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">Edit/Update Salary Components</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Department</label>
                <select 
                  value={selectedDepartment} 
                  onChange={(e) => setSelectedDepartment(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {departments.map(dept => (
                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Select Employee</label>
                <select 
                  value={selectedEmployee} 
                  onChange={(e) => setSelectedEmployee(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select an employee</option>
                  {employees
                    .filter(emp => emp.department === selectedDepartment)
                    .map(emp => (
                      <option key={emp.id} value={emp.id}>{emp.name}</option>
                    ))
                  }
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reason for Update</label>
                <select className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                  <option value="">Select a reason</option>
                  <option value="promotion">Promotion</option>
                  <option value="revision">Salary Revision</option>
                  <option value="correction">Correction</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-medium text-gray-700 mb-4">Current Salary Structure</h3>
                
                <div className="bg-gray-50 rounded-lg p-4 mb-4">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Basic Salary:</span>
                    <span className="font-medium">₹{salaryStructures[selectedDepartment].basic.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">HRA:</span>
                    <span className="font-medium">₹{salaryStructures[selectedDepartment].hra.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">DA:</span>
                    <span className="font-medium">₹{salaryStructures[selectedDepartment].da.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Conveyance:</span>
                    <span className="font-medium">₹{salaryStructures[selectedDepartment].conveyance.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-600">Medical:</span>
                    <span className="font-medium">₹{salaryStructures[selectedDepartment].medical.toLocaleString()}</span>
                  </div>
                  <div className="border-t pt-2 mt-2 flex justify-between items-center font-semibold">
                    <span className="text-gray-700">Net Salary:</span>
                    <span className="text-green-700">₹{calculateNetSalary(selectedDepartment).toLocaleString()}</span>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="font-medium text-gray-700 mb-4">Update Salary Components</h3>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Basic Salary</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter new basic salary"
                        value={salaryStructures[selectedDepartment].basic}
                        onChange={(e) => handleInputChange(e)}
                        name="basic"
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">HRA</label>
                    <div className="relative">
                      <span className="absolute left-3 top-2 text-gray-500">₹</span>
                      <input
                        type="number"
                        className="pl-8 w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter new HRA"
                        value={salaryStructures[selectedDepartment].hra}
                        onChange={(e) => handleInputChange(e)}
                        name="hra"
                      />
                    </div>
                  </div>
                  
                  <button 
                    onClick={handleUpdateSalary}
                    className="bg-gradient-to-r from-green-500 to-teal-600 text-white px-6 py-2 rounded-lg font-medium hover:shadow-md transition-shadow"
                  >
                    Update Salary
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalarySetup;